import { render, staticRenderFns } from "./ProductsFounders.vue?vue&type=template&id=01f691b1&"
import script from "./ProductsFounders.vue?vue&type=script&lang=js&"
export * from "./ProductsFounders.vue?vue&type=script&lang=js&"
import style0 from "./ProductsFounders.vue?vue&type=style&index=0&id=01f691b1&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports